var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVMarkStudio = function SvgVMarkStudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.504.447a.913.913 0 0 0-1.29 0L4.418 5.242l-2.36-2.36a.913.913 0 1 0-1.292 1.29L4.42 7.824l6.085-6.086a.913.913 0 0 0 0-1.29Z",
    fill: "#fff"
  })));
};
export default SvgVMarkStudio;